import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'
import packageJson from '../../../../../package.json'

export function initialize() {
    if (!import.meta.env.VITE_SENTRY_KEY || import.meta.env.MODE === 'development') {
        return
    }
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_KEY,
        environment: import.meta.env.VITE_ENV_NAME,
        release: `${packageJson.name}@${packageJson.version}`,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false }),
        ],
        beforeSend(event, _hint) {
            const msg = event.exception?.values?.[0]?.value || ''
            if (
                msg.includes('error loading dynamically imported module') ||
                msg.includes('Request failed with status code 401') ||
                msg.includes('Request aborted')
            ) {
                return null
            }

            if (event.exception) {
                Sentry.showReportDialog({
                    eventId: event.event_id,
                    user: { email: event.user?.email, name: event.user?.username },
                    lang: localStorage.getItem('lang')!,
                })
            }
            return event
        },

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: 0,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    })
}
